import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
    { to: "/", label: "Home" },
    { to: "/jobs", label: "Open Jobs" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header className="sticky top-0 z-40 bg-white border-b-2 border-slate-100" data-testid="site-navbar">
            <div className="diagonal-stripes h-1.5 w-full" />
            <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
                <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo-link">
                    <img
                        src="/tps-logo.jpg"
                        alt="Tower Staffing Inc. — Providing results through service"
                        className="h-14 w-auto"
                    />
                    <div className="hidden md:block leading-tight border-l-2 border-slate-200 pl-3">
                        <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-bold">Est. 1953 · Fort Wayne</div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            className={({ isActive }) =>
                                `font-heading uppercase text-sm font-bold tracking-wider relative py-2 transition-colors ${
                                    isActive ? "text-brand-orange" : "text-brand-navy hover:text-brand-orange"
                                }`
                            }
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        href="tel:2604837085"
                        className="flex items-center gap-2 text-brand-navy font-heading font-bold text-sm"
                        data-testid="navbar-phone"
                    >
                        <Phone className="h-4 w-4 text-brand-orange" />
                        260.483.7085
                    </a>
                    <Link
                        to="/apply"
                        className="bg-brand-orange text-white font-heading uppercase tracking-wider font-bold text-sm px-5 py-3 rounded-sm hover:bg-brand-navy transition-colors"
                        data-testid="navbar-apply-now-btn"
                    >
                        Apply Now
                    </Link>
                </div>

                <button
                    className="lg:hidden p-2 text-brand-navy"
                    onClick={() => setOpen(!open)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden bg-white border-t border-slate-100 px-4 py-4 space-y-3" data-testid="mobile-menu">
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            className="block font-heading uppercase font-bold text-brand-navy py-2"
                        >
                            {l.label}
                        </Link>
                    ))}
                    <Link
                        to="/apply"
                        onClick={() => setOpen(false)}
                        className="block bg-brand-orange text-white text-center font-heading uppercase tracking-wider font-bold px-5 py-3 rounded-sm"
                        data-testid="mobile-apply-now-btn"
                    >
                        Apply Now
                    </Link>
                </div>
            )}
        </header>
    );
}
